import { combineReducers } from 'redux';
import StudentReducer from './studentReducer';
import TeacherReducer from './teacherReducer';
export default combineReducers({
  StudentStore: StudentReducer,
  TeacherStore: TeacherReducer,
});
